(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-menu-open]').forEach(button => {
      if (button.dataset.initialized) return;
      button.dataset.initialized = 'true';
      const dialog = document.getElementById(button.getAttribute('aria-controls'));
      if (!dialog) return;
      const close = () => {
        dialog.close();
        button.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('menu-open');
      };
      button.addEventListener('click', () => {
        dialog.showModal();
        button.setAttribute('aria-expanded', 'true');
        document.body.classList.add('menu-open');
      });
      dialog.querySelector('[data-menu-close]')?.addEventListener('click', close);
      dialog.addEventListener('cancel', close);
      dialog.addEventListener('close', () => {
        button.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('menu-open');
        button.focus();
      });
      dialog.addEventListener('click', event => {
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
        }
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', () => document.body.classList.remove('menu-open'));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.nav-dropdown[open]').forEach(menu => menu.removeAttribute('open'));
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.desktop-nav .nav-dropdown[open]').forEach(menu => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  });
})();
